import React from 'react';
var __useId = React["useId".toString()] || function () {
  return void 0;
};
function useReactId() {
  var id = __useId();
  return id ? "mantine-".concat(id.replace(/:/g, "")) : "";
}
export { useReactId };